import { Skeleton } from "@/components/ui/skeleton";

export default function BookingConfirmationSkeleton() {
  return (
    <div className="mx-auto max-w-7xl px-4 pb-16 pt-4 sm:px-6 lg:px-8 md:max-w-5xl">
      {/* Success header */}
      <div className="flex flex-col items-center p-2 text-center">
        <Skeleton className="h-12 w-12 rounded-full" />
        <Skeleton className="mt-2 h-6 w-40" />
        <Skeleton className="mt-3 h-10 w-72" />
      </div>

      {/* Booking Summary */}
      <Skeleton className="mt-8 h-6 w-40" />

      <section className="mt-2 rounded-2xl bg-card px-4 py-6 shadow-xl md:p-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="mt-2 h-5 w-40" />
          </div>

          <div className="flex flex-col items-end">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="mt-2 h-5 w-32" />
          </div>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-4">
          <div>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="mt-2 h-5 w-28" />
          </div>

          <div className="flex flex-col items-end">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="mt-2 h-5 w-40" />
          </div>
        </div>
      </section>

      {/* Trip Details */}
      <Skeleton className="mt-8 h-6 w-32" />

      <section className="mt-2 rounded-2xl bg-card px-4 py-6 shadow-xl md:p-6">
        <Skeleton className="h-5 w-64" />

        <div className="mt-5 flex gap-4">
          <Skeleton className="h-12 w-40" />
          <Skeleton className="h-12 w-40" />
        </div>
      </section>

      {/* Contact */}
      <Skeleton className="mt-8 h-6 w-40" />

      <section className="mt-2 rounded-2xl bg-card px-4 py-6 shadow-xl md:p-6">
        <div className="grid gap-4 md:grid-cols-3">
          <div>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="mt-2 h-5 w-32" />
          </div>

          <div>
            <Skeleton className="h-4 w-28" />
            <Skeleton className="mt-2 h-5 w-40" />
          </div>

          <div>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="mt-2 h-5 w-32" />
          </div>
        </div>
      </section>

      {/* Price Breakdown */}
      <Skeleton className="mt-8 h-6 w-40" />

      <section className="mt-2 overflow-hidden rounded-2xl bg-card shadow-xl">
        <Skeleton className="h-10 w-full rounded-none" />

        <div className="space-y-4 px-4 py-4">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-px w-full" />

          <div className="flex justify-between">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-5 w-24" />
          </div>
        </div>
      </section>

      {/* Current Balance */}
      <Skeleton className="mt-8 h-6 w-40" />

      <section className="mt-2 rounded-2xl bg-card px-4 py-6 shadow-xl md:p-6">
        <Skeleton className="h-5 w-64" />

        <div className="mt-5 grid grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index}>
              <Skeleton className="h-8 w-20" />
              <Skeleton className="mt-2 h-8 w-12" />
            </div>
          ))}
        </div>
      </section>

      {/* Buttons */}
      <div className="mt-8 flex flex-col gap-8 md:flex-row">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </div>
  );
}